import { useEffect, useRef, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DBRequest, useConfig } from '../../../api/api';
import { tokens } from '../../../global/theme/tokens';
import ExoInfiniteScroll from '../../../components/exo/ExoInfiniteScroll';
import TypeSkeleton from '../../../components/form/form-fields/TypeSkeleton';
import TimeEntryCard from './TimeEntryCard';

const TimeManagerHistory = ({ employeeFilter = [] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const [apiData, setApiData] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (!config) return;
    fetchHistory();
  }, [config, employeeFilter]);

  function fetchHistory() {
    setApiData(null);

    const params = new URLSearchParams();
    params.set('sortBy', 'timeStart');
    params.set('sortOrder', 'desc');
    params.append('with[]', 'employee');
    params.append('with[]', 'project');
    params.append('with[]', 'workPackage');
    employeeFilter.forEach((id) => {
      params.append('userIds[]', id);
    });

    DBRequest({
      config,
      path: `timetrackings?${params.toString()}`,
      onResponse: setApiData,
    });
  }

  if (!apiData) {
    return <TypeSkeleton n={8} />;
  }

  if (apiData.data && apiData.data.length === 0) {
    return (
      <Box
        className="flex items-center justify-center rounded-lg backdrop-blur-lg p-8"
        sx={{ bgcolor: colors.glass }}
      >
        <Typography sx={{ opacity: 0.7 }} fontSize="14px">
          {t('No time entries found')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      ref={scrollRef}
      className="flex flex-col h-full pb-2 md:pb-0 overflow-auto px-1 sm:px-0 rounded-lg backdrop-blur-lg"
      sx={{ bgcolor: colors.glass }}
    >
      <ExoInfiniteScroll
        apiData={apiData}
        setApiData={setApiData}
        scrollContainerRef={scrollRef}
      >
        {apiData.data.map((entry) => (
          <TimeEntryCard key={entry.id} entry={entry} />
        ))}
      </ExoInfiniteScroll>
    </Box>
  );
};

export default TimeManagerHistory;
